import { SET_PAGINATED_FEEDBACK } from '../actions'

const feedbackReducer = (state = [], action) => {
  switch (action.type) {
    case SET_PAGINATED_FEEDBACK: {
      return action.feedback
    }
    default:
      return state
  }
}

export default feedbackReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/feedback.js